import { Box, Grid } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'

export default function ReactHome() {
  const [code, setcode] = useState(null)
  useEffect(() => {
    fetch('https://raw.githubusercontent.com/hayskytech/haysky-lms/master/react/index.html')
      .then(res => res.text())
      .then(text => setcode(text))
  }, [])
  return (
    <Box pt={{ base: "180px", md: "80px", xl: "80px" }}>
      <Grid
        mb='20px'
        gridTemplateColumns={{ xl: "repeat(3, 1fr)", "2xl": "1fr 0.46fr" }}
        gap={{ base: "20px", xl: "20px" }}
        display={{ base: "block", xl: "grid" }}>

        <div dangerouslySetInnerHTML={{ __html: code }}></div>
      </Grid>

    </Box>
  )
}
